//Module Keys
let locales = {};

//Merge Views
import tab from 'Modules/rawData/.components/tab/lan/es';
import showRawData from 'Modules/rawData/.components/showRawData/lan/es';
import videoPlayer from 'Modules/rawData/.components/videoPlayer/lan/es';

locales = { ...locales, ...tab, ...showRawData, ...videoPlayer };


export default locales;